import React, {Component, PropTypes} from 'react';

import zoomerStore from '../../stores/zoomer';
import StoreConnect from '../../flux/StoreConnect';

import config from '../../config';

class SIMMiniMap extends Component {

  getEyeglassStyle () {
    // This RATIO comes from CSS, don't change it
    // TODO, check if we can read it from JS instead of setting it
    var ratio = 0.25;
    const {scale, translateX, translateY} = this.props.zoomer;

    var percentage = 100 / scale;
    var top = (translateY / scale) * (ratio) * -1;
    var left = (translateX / scale) * (ratio) * -1;

    return {
      width:  `${percentage}%`,
      height: `${percentage}%`,
      top:    top,
      left:   left
    };
  }

  render () {
    if (!config.minimap.show) {
      return false;
    }

    var eyeglassStyle = this.getEyeglassStyle();

    var isActive = this.props.zoomer.scale > config.minimap.showAtScaleGreaterThan; // TODO, check performance

    var miniMapClass = 'minimap';
    miniMapClass += isActive ? ' is-active' : '';

    var eyeglassClass = 'minimap__eyeglass';
    eyeglassClass += isActive ? ' is-active' : '';

    return (
      <div className={miniMapClass}>
        <div style={eyeglassStyle} className={eyeglassClass}></div>
        {this.props.children}
      </div>
    );
  }
}

export default StoreConnect(SIMMiniMap, {zoomer: zoomerStore});

SIMMiniMap.propTypes = {
  zoomer: PropTypes.shape({
    scale:      PropTypes.number.isRequired,
    translateX: PropTypes.number.isRequired,
    translateY: PropTypes.number.isRequired
  })
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/minimap/index.jsx